import { useNotifications } from '../../store/useStore';
import { eventiService } from '../../lib/eventi/eventiService';
import { messaggioErrore } from '../../lib/eventi/errori';
import type { Etichetta, Evento } from '../../lib/eventi/tipi';
import { ModuloImpostazioni, type CampiImpostazioni } from './ModuloImpostazioni';

type Props = {
  evento: Evento;
  etichette: Etichetta[];
  onEventoCambiato: () => Promise<void>;
  onPartecipantiCambiati: () => Promise<void>;
};

/**
 * La scheda Impostazioni: solo come funziona l'evento (lista, pagine, regole,
 * email automatiche). Il programma e i posti stanno nella scheda Programma;
 * aprire e chiudere le richieste si fa dalla testata.
 */
export function SchedaImpostazioni({ evento, etichette, onEventoCambiato, onPartecipantiCambiati }: Props) {
  const { addNotification } = useNotifications();

  const salva = async (campi: CampiImpostazioni) => {
    try {
      const nuovi = await eventiService.salvaImpostazioni(evento.id, { ...campi, scelte_aperte: evento.scelte_aperte });
      addNotification({
        type: 'success',
        title: 'Impostazioni salvate',
        message: nuovi > 0 ? `${nuovi} contatti della lista sono diventati partecipanti.` : undefined,
      });
      await Promise.all([onEventoCambiato(), nuovi > 0 ? onPartecipantiCambiati() : Promise.resolve()]);
    } catch (e) {
      addNotification({ type: 'error', title: 'Non riesco a salvare le impostazioni', message: messaggioErrore(e) });
    }
  };

  return <ModuloImpostazioni evento={evento} etichette={etichette} onSalva={salva} />;
}
